<template lang="pug">
  v-container
    v-row
      v-col(cols="12" md="2")
        //- export-purchase-xls
        report-recieved-inventories(
          :date-start="dateStart"
          :date-end="dateEnd"
        )
      v-col(
        cols="3"
        md="3"
        sm="12"
      )
        v-text-field(
          v-model="dateStart"
          label="Date Start"
          type="date"
          hide-details
          clearable
        )
      v-col(
        cols="3"
        md="3"
        sm="12"
      )
        v-text-field(
          v-model="dateEnd"
          label="Date End"
          type="date"
          hide-details
          clearable
        )
      v-spacer
      v-col(
        cols="3"
        md="3"
        sm="12"
      )
        v-text-field(
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
          :loading="rcvInvLoading"
        )
    div(style="overflow: auto;")
      v-responsive()
        v-data-table(
          dense
          :headers="headers"
          :items-per-page.sync="itemsPerPage"
          :page.sync="page"
          :items="rcvInvList"
          single-expand
          show-expand
          :server-items-length="rcvInvCount"
          :footer-props="{ 'items-per-page-options': [5, 10 ,15, 20] }"
          :loading="rcvInvLoading || rcvInvCounting"
          class="elevation-0"
        )
          template(v-slot:item="{ item, expand, isExpanded }")
            tr
              td.border-right(align="right" width="120px") {{ (`${item.receipt_no}`) }}
              td.border-right(align="right" width="100px") {{ item.receipts.length }}
              td.border-right(align="right") {{ (item.amount || 0).phpFormat() }}
              td.border-right(align="right") {{ (item.date_recieved || '').dateFormat() }}
              td.border-right(align="center" width="100px")
                v-chip(
                  x-small
                  dark
                  :color="item.is_paid ? 'green' : 'orange'"
                  @click="togglePaidStatus(item)"
                ) {{ item.is_paid ? 'Paid' : 'Unpaid' }}
              td(class="flex items-center")
                v-btn(
                  v-if="authPermissions.has('purchases:void')"
                  color="purple"
                  x-small
                  text
                  @click="voidItem(item.receipt_no)"
                )
                  v-icon mdi-eraser-variant

                <!-- PDF -->

                v-tooltip(bottom)
                  template(#activator='{ on, attrs }')
                    v-btn(v-bind='attrs' v-on='on' color='blue' text='' x-small='' @click='downloadReceipt(item)')
                      v-icon(small='') mdi-file-pdf-box
                  span Download PDF
                v-btn(
                  :class="isExpanded ? 'is-expanded' : ''"
                  color="primary"
                  x-small
                  text
                  @click="expand(!isExpanded)"
                )
                  v-icon mdi-plus
          template(v-slot:expanded-item="{ item }")
            td(colspan="6")
              v-row.ma-0.border-bottom
                v-col.py-0(cols="3" align="center")
                  strong Product Name
                v-col.py-0(cols="3" align="center")
                  strong Brand Name
                v-col.py-0(cols="2" align="center")
                  strong Cost
                v-col.py-0(cols="1" align="center")
                  strong Quantity
                v-col.py-0(cols="1" align="center")
                  strong Unit
                v-col.py-0(cols="2" align="center")
                  strong Amount
              v-row.ma-0.border-bottom(v-for="(subItem, index) in item.receipts" :key="index")
                v-col.py-0.border-right(cols="3" align="left")
                  v-btn(
                    v-if="authPermissions.has('purchases:edit')"
                    color="yellow"
                    icon
                    small
                    @click="editRecievedInventory(subItem)"
                  )
                    v-icon mdi-pencil
                  span {{ subItem.product_name }}
                v-col.py-0.border-right(cols="3" align="left") {{ subItem.brand_name }}
                v-col.py-0.border-right(cols="2" align="right") {{ (subItem.cost || 0).phpFormat() }}
                v-col.py-0.border-right(cols="1" align="right") {{ subItem.quantity }}
                v-col.py-0.border-right(cols="1" align="right") {{ subItem.unit }}
                v-col.py-0(cols="2" align="right") {{ ((subItem.quantity * subItem.cost) || 0).phpFormat() }}
            //- tr
            //-   td
            //-     v-tooltip(bottom)
            //-       template(v-slot:activator="{ on, attrs }")
            //-         v-btn(
            //-           class="mx-2"
            //-           fab
            //-           dark
            //-           small
            //-           v-bind="attrs"
            //-           v-on="on"
            //-           color="yellow"
            //-           @click="editRecievedInventory(row.item)"
            //-         )
            //-           v-icon(dark) mdi-pencil
            //-       span Edit
            //-   td {{ row.item.supplier_id }}-{{ row.item.stock_code  }}
            //-   td {{ row.item.product_name }}
            //-   td {{ row.item.brand_name }}
            //-   td ₱ {{ formatMoney(row.item.cost) }}
            //-   td {{ row.item.quantity }} {{ row.item.unit }}
            //-   td ₱ {{ formatMoney(row.item.total_amount) }}
            //-   td {{ dateFormat(row.item.date_recieved) }}
</template>
<style lang="scss">
.border-right {
  border-right: 1px lightgray solid;
}

.border-bottom {
  border-bottom: 1px lightgray solid;
}

.v-btn.is-expanded .v-icon {
  transform: rotate(-45deg);
}
</style>
<script>
import { mapState, mapActions } from 'vuex'
import { moneyMixin } from './../../mixins/helper.mixins'
import searchDelay from '@/extra-functions/searchDelay.extra'
import { apiVars } from '@/extra-functions/api-helper.extra'
import rcvInvRepository from '@/repositories/recieved-inventory.repository'
import { errorHandler } from '../../../../extra-functions/store.extra'
import {
  ConfirmPopup,
  ErrorPopup,
  LoadingPopup,
  SuccessPopup,
} from '../../../../lib/utils'
import appAxios from '../../../../extra-functions/axios.extra'
import PurchaseReceiptPDF from '@/pdf/purchase-receipt.pdf'

const delayedSearch = searchDelay()
function tableVars() {
  return {
    headers: [
      { text: 'Receipt No', value: 'receipt_no' },
      { text: 'Items', value: 'receipts.length' },
      { text: 'Total Amount', value: 'amount' },
      { text: 'Date Purchased', value: 'date_recieved' },
      { text: 'Payment', value: 'is_paid', sortable: false },
      { text: '', sortable: false, value: 'data-table-expand' },
    ],
    itemsPerPage: 5,
    page: 1,
    search: null,
    dateStart: null,
    dateEnd: null,
  }
}

export default {
  name: 'VIndexRecievedInventories',
  components: {
    ExportPurchaseXls: () => import('./Export.vue'),
    ReportRecievedInventories: () => import('./Report.vue'),
  },
  data() {
    return {
      ...tableVars(),
      ...apiVars('rcvInv', {
        count: 0,
        counting: false,
      }),
    }
  },
  created() {
    this.getData()
  },
  computed: {
    ...mapState({
      totalCount: (state) => state.recievedInventory.dataCount,
      fetching: (state) => state.recievedInventory.fetching,
      storeId: (state) => state.settings.storeId,
      rcvInvUpdated: (state) => state.recievedInventory.channelUpdate,
      authPermissions: (state) => state.auth.userPermissions,
      token: (state) => state.auth.token,
    }),
  },
  watch: {
    itemsPerPage(val) {
      this.rcvInvLoading = true
      delayedSearch(() => {
        this.getRcvInv()
      })
    },
    page(val) {
      this.rcvInvLoading = true
      delayedSearch(() => {
        this.getRcvInv()
      })
    },
    search() {
      this.getData()
    },
    dateStart() {
      this.getData()
    },
    dateEnd() {
      this.getData()
    },
    rcvInvUpdated() {
      this.getData()
    },
  },
  methods: {
    ...mapActions({
      // fetch: 'recievedInventory/fetch',
      // fetchDataCount: 'recievedInventory/fetchDataCount',
    }),
    async downloadReceipt(item) {
      try {
        LoadingPopup.fire('Generating purchase receipt...')

        PurchaseReceiptPDF(item)

        LoadingPopup.close()
      } catch (e) {
        console.error(e)
        LoadingPopup.close()
        ErrorPopup.fire('Failed to generate PDF.')
      }
    },
    getRcvInv() {
      const { storeId } = this.$store.state.settings
      const params = {
        index: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
        ...this.filters(),
        storeId,
      }
      rcvInvRepository
        .receipts(params)
        .then(({ data }) => {
          this.rcvInvList = data
        })
        .catch((e) => {
          this.rcvInvErrors = errorHandler(e)
        })
        .then(() => {
          this.rcvInvLoading = false
        })
    },
    getRcvInvCount() {
      const { storeId } = this.$store.state.settings
      const params = {
        ...this.filters(),
        storeId,
      }
      rcvInvRepository
        .receiptCount(params)
        .then(({ data }) => {
          this.rcvInvCount = data
        })
        .catch((e) => {})
        .then(() => {
          this.rcvInvCounting = false
        })
    },
    editStock(stockData) {
      this.$emit('editStock', stockData)
    },
    editRecievedInventory(item) {
      this.$emit('edit', item)
    },
    dateFormat(ndate) {
      const date = new Date(ndate)
      const year = date.getFullYear()
      const month = `${date.getMonth() + 1}`.padStart(2, '0')
      const day = `${date.getDate()}`.padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    getData() {
      this.rcvInvLoading = true
      this.rcvInvCounting = true
      delayedSearch(() => {
        this.page = 1
        this.getRcvInv()
        this.getRcvInvCount()
      })
    },
    filters() {
      return {
        search: this.search,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
      }
    },
    async togglePaidStatus(item) {
      try {
        if (!this.authPermissions.has('purchases:paid_status_edit')) return
        const isPaid = !item.is_paid
        const { isConfirmed } = await ConfirmPopup.fire(
          `Mark Receipt #${item.receipt_no} as ${isPaid ? 'Paid' : 'Unpaid'}?`,
        )
        if (!isConfirmed) return
        LoadingPopup.fire('Updating Payment Status')
        await rcvInvRepository.updatePaidStatus({
          receipt_no: item.receipt_no,
          is_paid: isPaid,
        })
        SuccessPopup.fire(
          `Receipt ${item.receipt_no} marked as ${isPaid ? 'Paid' : 'Unpaid'}`,
        )
        this.getData()
      } catch (e) {
        console.error(e)
        ErrorPopup.fire()
      }
    },
    async voidItem(receiptNo) {
      try {
        if (!this.authPermissions.has('purchases:void')) return
        const { isConfirmed } = await ConfirmPopup.fire(
          `Confirm Void #${receiptNo}`,
        )
        if (!isConfirmed) return
        LoadingPopup.fire('Removing Item From Database')
        await appAxios(this.token).post('/recieved-inventories/void', {
          receipt_no: receiptNo,
        })
        SuccessPopup.fire(`Receipt ${receiptNo} successfully void`)
        this.getData()
      } catch (e) {
        console.error(e)
        ErrorPopup.fire()
      }
    },
  },
  mixins: [moneyMixin],
}
</script>
